/* Currency for display. Every screen needs the same two things — which currency
   and how to convert into it — so they come from one place rather than being
   rebuilt on each screen. */

import { useStore } from './store';

export function useDisplay() {
  const { state } = useStore();
  const currency = state.settings.displayCurrency;
  const rate = state.fx?.usdPln;
  return {
    currency,
    toDisplay: (usd: number) => (currency === 'PLN' && rate ? usd * rate : usd),
  };
}
